import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';

//conv dd/mm/yyyy to timestamp

export function leapYear(control: FormControl) {
    let leapyear = control.value;
    let day, month, year;
    if (leapyear) {
        [day, month, year] = leapyear.split('/').map(e => parseInt(e));
        if (day && month && year) {
            //check if 18y old
            var today = new Date();
            var age = today.getFullYear() - year;

            if (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0))
                return {
                    leapyear: 'leap'
                }
        }
    }
    return null;
}

@Directive({
    selector: '[allowFutureOnlyValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: leapYear,
            multi: true
        }
    ]
})
export class AllowFutureOnlyValidator {
}